import { render, staticRenderFns } from "./cModalViewDispatch.vue?vue&type=template&id=097f67b4"
import script from "./cModalViewDispatch.vue?vue&type=script&lang=js"
export * from "./cModalViewDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports